// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_wbF","cls2":"CreateSocialItemModal-cls2_nSd CreateSocialItemModal-cls1_wbF"};